import { render, staticRenderFns } from "./activity-order-list.vue?vue&type=template&id=08826299&lang=pug&"
import script from "./activity-order-list.vue?vue&type=script&lang=js&"
export * from "./activity-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports